import React from 'react';

import { useQueryGetOpcProjectsList } from 'api/queries/getOpcProjectsList.query';

import { Alert } from 'components/DesignSystem/Alert';
import { OpcHeader } from 'components/pages/OpcCredentialsPage/components/OpcCredentials/components/OpcHeader/OpcHeader';
import classes from 'components/pages/OpcViewPage/components/OpcVIew/OpcView.module.scss';
import { OpcConnectionInfo } from 'components/pages/OpcViewPage/components/OpcVIew/components/OpcConnectionInfo/OpcConnectionInfo';
import { OpcVerifiedAccess } from 'components/pages/OpcViewPage/components/OpcVIew/components/OpcVerifiedAccess/OpcVerifiedAccess';

export const OpcView = () => {
    const { isError } = useQueryGetOpcProjectsList();
    return (
        <div className={classes.OpcVIew}>
            <OpcHeader />
            {isError && (
                <Alert severity={'warning'} sx={{ width: '780px' }}>
                    Possible causes: Credentials are incorrect; The password may have changed in Oracle Primavera Cloud;
                    The account may no longer have the required access; The host may be unreachable
                </Alert>
            )}
            <OpcConnectionInfo />
            <OpcVerifiedAccess />
        </div>
    );
};
